export default "__VITE_ASSET__DPebVaSy__"